import React from 'react'
import Header from '../components/Header'
import "./Styles.css"
import Footer from '../Sections/Footer'


const Returns = () => {
    return (
        <div className='pages-wrapper-main'>
            <Header />
            <div className='heading2'>Returns</div>

            <div className='pages'>
                <h5>1. Eligibility:</h5>

                Our Returns Policy applies to clients who have purchased internship services from Intern Crafters.

                <br></br>
                <br></br>
                <h5> 2. Return Process:</h5>

                If you are unsatisfied with our internship services or wish to cancel your enrollment, please follow these steps:



                Notification: Notify us of your decision to cancel your enrollment or request a return of fees by contacting our customer support team at interncrafters@gmail.com.



                Reason for Return: Provide a brief explanation of the reason for your return request.



                Documentation: Submit any necessary documentation related to your enrollment, such as proof of payment or enrollment details.

                <br></br>
                <br></br>

                <h5>3. Refund Options:</h5>

                Upon receiving your return request, we will assess your eligibility for a refund. Refund options may include:



                Partial Refund: Depending on the stage of your enrollment and the services rendered, a partial refund may be offered.



                Credit Towards Future Enrollment: We may offer a credit towards a future internship enrollment with us.

                <br></br>
                <br></br>

                <h5>4. Timeline:</h5>

                Submission Deadline: Return requests must be submitted within 10 days of the start date of your internship.



                Processing Time: Refunds will be processed within 14 days of approval of your return request.

                <br></br>
                <br></br>

                <h5>5. Damaged or Defective Services:</h5>

                If you believe that our internship services were not delivered as promised or were deficient in any way, please contact us immediately to discuss your concerns. We are committed to resolving any issues promptly and ensuring your satisfaction.

                <br></br>
                <br></br>

                <h5> 6. Contact Information:</h5>

                For any inquiries or assistance regarding our Returns Policy or internship services, please contact our customer support team at interncrafters@gmail.com. We are here to help and address any questions or concerns you may have.
            </div>
            <Footer />
        </div>
    )
}

export default Returns
